// extracted by mini-css-extract-plugin
export default {"labelPlaceHolder":"styles__labelPlaceHolder___n5KdW"};